import type { ColumnType } from 'antd/lib/table';
import { TFunction } from 'i18next';

export const titleColumn = <T extends { title?: string }>(
  t: TFunction,
): ColumnType<T> => ({
    title: t('Title'),
    dataIndex: 'title',
  });
